import { UserRoles } from 'src/types/user';

const useCheckRole = (roleToCheck: UserRoles, user) => {
  if (user?.roles.length) {
    return user.roles.includes(roleToCheck);
  }
  return false;
};

export default useCheckRole;